<template>

    <draggable class="flow-area white-background" v-model="flow.steps" style="width:100%" group="elements" handle=".drag-handle" :animation="350" @end="moved">
        <div v-for="step in flow.steps" @keydown.stop="keyPressed($event, step)" :key="step._id">
            <Step :ref="`step${step._id}`"  :step="step" :level="level" />
        </div>
    </draggable>

</template>

<script>
import DataHelpers from '../helpers/DataHelpers'
import Firestore from '../data/Firestore'
import Step from './Step'
import Utilities from '../helpers/Utilities'
import ObjectArrayHelpers from '../helpers/ObjectArrayHelpers'
import { addDays } from 'date-fns'
import draggable from 'vuedraggable'
import StringHelpers from '../helpers/StringHelpers'
import FlowHelpers from './FlowHelpers'


export default {
    data() {
        return {
            flow: {
                steps: [],
            },
            allFlows: [],
        }
    },

    inject: ['$page'],

    components: {
        Step, draggable
    },
    
    props: {
        level: {
            type: Number,
            default: 0
        },
        id: String,
    },

    computed: {

        selectedSteps() {
            return this.flow.steps.filter(o => o._selected)
        },

        chosenSteps() {
            let steps =  [...this.selectedSteps]
            if(this.flow.focused)
                steps.push(this.flow.focused)
            return steps
        }
    },

    methods: {
        getFlowFromCache(id) {
            return this.$page.allFlows.find(o => o._id == id)
        },

        getSummary() {

        },

        toggleStepValue(step, key) {
            this.$set(step, key, !Boolean(step[key]))
        },
        moved(event) {
            console.log('Moved to ', event.to)
        },

        focusFirst() {
            const firstItem = this.flow.steps[0]
            if(firstItem)
                Utilities.focusById('step' + firstItem._id)
        },

        selectStep(step) {
            this.$set(step, '_selected', true)
        },

        toggleSelection(step) {
            ObjectArrayHelpers.toggleSelection(step)
        },

        addStep(previousStep) {
            
            let vm = this
            const newStep = {...previousStep}

            newStep._parent = this.flow
            newStep.value = null
            delete newStep.title
            delete newStep.type
            Firestore.removeMeta(newStep)
            newStep._id = Firestore.getId()
            const idx = this.flow.steps.findIndex(o => o._id == previousStep._id)
            this.flow.steps.splice(idx + 1, 0, newStep)

            Utilities.focusById('step' + newStep._id)

            this.selectStep(newStep)
    
        },

        editStep(step) {
            this.$page.designing = true
            this.selectStep(step)
        },

        incrementDueDate(days = 1) {
            this.$page.getSelectedSteps().forEach(step => {
                if(!step.due)
                    this.$set(step, 'due', new Date() )
                this.$set(step, 'due', addDays(step.due, days))
                if(!step.assigned)
                    this.$set(step, 'assigned', DataHelpers.getUser())
            }) 
        },

        removeStep(step) {
            const idx = this.flow.steps.findIndex(o => o._id == step._id)
            this.flow.steps.splice(idx, 1)
        },

        focusNextStep(step) {
            let nextStep = ObjectArrayHelpers.getNextItem(this.flow.steps, step)
            if(!nextStep)
                nextStep = this.flow.steps[0]  
            Utilities.focusById('step' + nextStep._id)
        },

        focusPreviousStep(step) {
            let previousStep = ObjectArrayHelpers.getPreviousItem(this.flow.steps, step)
            if(!previousStep)
                previousStep = this.flow.steps[this.flow.steps.length - 1]   
            Utilities.focusById('step' + previousStep._id)
        },

        keyPressed(event, step) {
            if((event.ctrlKey || event.metaKey) && event.key == "ArrowDown") {
                this.addStep(step)
                return
            }

            //Cycle important...

            if((event.ctrlKey || event.metaKey) && event.code == 'KeyI') {
                let newImportance
                let MAX_IMPORTANCE = 3
                if(!step.important)
                    newImportance = 1
                else if(step.important == MAX_IMPORTANCE)
                    newImportance = 0
                else
                    newImportance = step.important + 1

                
                this.$set(step, 'important', newImportance)
                
                event.preventDefault()
                return
            }


            if(event.key == 'ArrowDown') {
                this.focusNextStep(step)
                return
            }

            if(event.key == 'ArrowUp') {
                this.focusPreviousStep(step)
                return
            }

            if(event.key == 'ArrowRight') {
                this.incrementDueDate()
                return
            }
            if(event.key == 'ArrowLeft') {
                this.incrementDueDate(-1)
                return
            }
        
            if(event.keyCode == 32) {       //Spacebar
                this.toggleSelection(step)
                return
            }

            if(event.key == 'Escape') { // keyCode 27
                step.$page.designing = false
                return
            }

            if(event.key == "Enter" && ObjectArrayHelpers.isLastItem(this.flow.steps, step)) {
                if(step.title)
                    this.addStep(step)
                else {
                    this.removeStep(step)
                    this.flow.designing = false
                }
                return
            }

            if(event.key == 'Shift')
                return

            if(event.key >= 'a' && event.key <= 'z')
                this.$page.showActivity(event.key)
            console.log('opendi', event.key)
        },
    },

    async created() {
        let flow
        flow = this.getFlowFromCache(this.id)
        if(flow)
            this.flow = flow
        else {
            this.flow = await FlowHelpers.fetchFlow(this.id)
            this.$page.allFlows.push(this.flow)
        }
    },

}
</script>

<style scoped>
.flow-area {
    border-radius:3px;
}
</style>




// WEBPACK FOOTER //
// Flow.vue?4915cdee